export default __webpack_public_path__ + "static/media/Screenshot 2022-11-14 at 12.36.30 PM.e7281f6d.png";